export const communitiesPaths = {
  onboarding: () => "/getting-started" as const,
  templates: (communityId: string) => `/communities/${communityId}/templates`,
  questions: (communityId: string) => `/communities/${communityId}/questions`,
  questionsWithVariant: (communityId: string, variant: string) =>
    `${communitiesPaths.questions(communityId)}?variant=${variant}`,
  feed: () => "/feed",
  adminRecap2025: () => "/settings/recap-2025",
  recap2025ForMembersAndNonMembers: () => "/2025",
};

export const memberDirectoryPath = () => "/members";
